var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountingCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 185,
    viewBox: "0 0 246 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5438_171229)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 185,
    fill: "url(#paint0_linear_5438_171229)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter0_ddd_5438_171229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: -0.5,
    r: 210.5,
    fill: "#FFF2E9"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter1_ddd_5438_171229)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 134,
    fill: "#FFF2E9"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter2_ddd_5438_171229)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 74,
    fill: "#FFF2E9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.971 160.611C171.971 161.953 171.726 162.925 171.242 163.501C170.951 163.799 170.596 164.029 170.204 164.173C169.811 164.318 169.391 164.373 168.974 164.336C168.553 164.377 168.128 164.321 167.734 164.171C167.339 164.021 166.986 163.782 166.702 163.473C166.161 162.618 165.911 161.615 165.989 160.61V147.691H160.055V160.907C160.055 163.521 160.843 165.545 162.397 166.922C163.938 168.287 166.15 168.979 168.974 168.979C171.882 168.979 174.12 168.274 175.625 166.882C177.13 165.49 177.907 163.468 177.907 160.893V147.691H171.971V160.611ZM172.801 148.51H177.077V160.896C177.077 163.236 176.398 165.049 175.058 166.287C173.719 167.524 171.666 168.163 168.974 168.163C166.362 168.163 164.336 167.54 162.952 166.315C161.58 165.1 160.885 163.281 160.885 160.91V148.51H165.16V160.611C165.078 161.796 165.388 162.976 166.044 163.972C166.402 164.384 166.855 164.705 167.364 164.911C167.873 165.116 168.424 165.2 168.972 165.155C169.512 165.196 170.054 165.115 170.557 164.919C171.061 164.723 171.512 164.417 171.878 164.024C172.489 163.297 172.799 162.148 172.799 160.611L172.801 148.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.619 169H211.192V164.261H202.527V159.913H210.512V155.175H202.527V152.41H211.193V147.671H196.62L196.619 169ZM197.448 148.501H210.364V151.582H201.697V156.001H209.682V159.082H201.697V165.087H210.364V168.168H197.448V148.501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.518 164.886H219.206C220.565 164.886 221.472 164.877 221.978 164.859C222.566 164.832 223.144 164.697 223.682 164.462C224.195 164.259 224.624 163.89 224.897 163.415C225.149 162.956 225.277 162.44 225.27 161.918C225.3 161.32 225.139 160.728 224.81 160.225C224.472 159.784 224.005 159.456 223.472 159.286C223.017 159.135 222.54 159.06 222.06 159.064C221.513 159.051 220.777 159.044 219.873 159.044H218.516L218.518 164.886ZM219.348 159.863H219.875C220.769 159.863 221.498 159.87 222.042 159.883C222.431 159.878 222.818 159.936 223.188 160.054C223.565 160.169 223.896 160.395 224.139 160.701C224.364 161.066 224.471 161.491 224.443 161.918C224.45 162.302 224.358 162.681 224.174 163.02C223.989 163.336 223.7 163.579 223.354 163.71C222.91 163.905 222.433 164.017 221.947 164.041C221.467 164.057 220.616 164.066 219.346 164.067L219.348 159.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.754 158.701C229.112 158.014 228.306 157.496 227.408 157.195C227.984 156.819 228.471 156.326 228.836 155.748C229.38 154.881 229.661 153.879 229.645 152.86C229.661 151.998 229.458 151.146 229.056 150.381C228.642 149.639 228.017 149.033 227.258 148.638C226.544 148.25 225.765 147.99 224.958 147.871C223.812 147.734 222.658 147.675 221.504 147.695H213.91V163.645C213.656 163.734 213.441 163.908 213.303 164.136C213.165 164.365 213.113 164.634 213.155 164.897C213.197 165.16 213.332 165.4 213.534 165.575C213.737 165.751 213.996 165.851 214.265 165.858C214.535 165.865 214.799 165.779 215.011 165.614C215.223 165.45 215.369 165.217 215.426 164.957C215.482 164.696 215.444 164.425 215.319 164.189C215.194 163.954 214.989 163.769 214.74 163.666V148.52H221.504C222.617 148.5 223.73 148.556 224.836 148.687C225.546 148.792 226.233 149.021 226.862 149.363C227.48 149.682 227.99 150.174 228.328 150.777C228.663 151.42 228.831 152.136 228.816 152.86C228.83 153.722 228.595 154.57 228.136 155.304C227.694 156.001 227.042 156.545 226.272 156.86L226.019 156.966V157.688L226.348 157.757C227.419 157.952 228.399 158.478 229.146 159.26C229.864 160.108 230.23 161.194 230.169 162.298C230.188 163.159 230.007 164.013 229.639 164.794C229.304 165.482 228.816 166.087 228.211 166.563C227.51 167.122 226.703 167.536 225.837 167.781C224.734 168.052 223.599 168.177 222.462 168.15H214.379V168.982H222.46C223.672 169.009 224.881 168.874 226.056 168.582C227.028 168.308 227.933 167.844 228.719 167.218C229.422 166.665 229.988 165.963 230.378 165.164C230.802 164.269 231.013 163.289 230.994 162.301C231.059 160.989 230.616 159.702 229.754 158.701V158.701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.632 168.151H180.893V148.52H185.169V165.076H188.67C188.768 165.257 188.914 165.408 189.092 165.513C189.27 165.618 189.474 165.674 189.682 165.674C189.89 165.674 190.094 165.618 190.272 165.513C190.451 165.408 190.597 165.257 190.695 165.076L190.772 164.893C190.812 164.779 190.834 164.66 190.835 164.539C190.835 164.263 190.734 163.997 190.55 163.79C190.366 163.583 190.112 163.449 189.835 163.413C189.558 163.378 189.278 163.443 189.046 163.597C188.814 163.75 188.647 163.982 188.576 164.248H186V147.692H180.065V168.982H194.462V164.251H193.633L193.632 168.151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.662 148.512C155.75 148.765 155.924 148.978 156.155 149.117C156.386 149.255 156.658 149.31 156.926 149.271C157.193 149.232 157.438 149.102 157.618 148.903C157.798 148.705 157.902 148.45 157.912 148.184C157.922 147.918 157.838 147.656 157.673 147.445C157.508 147.234 157.274 147.086 157.01 147.028C156.746 146.969 156.47 147.004 156.23 147.125C155.989 147.246 155.799 147.447 155.693 147.691H147.308V152.167H151.962V159.836C151.962 160.533 151.951 161.181 151.929 161.761C151.919 162.24 151.811 162.712 151.614 163.149C151.444 163.524 151.145 163.827 150.771 164.006C150.176 164.26 149.529 164.373 148.882 164.338C148.344 164.353 147.806 164.289 147.288 164.148C146.854 164.012 146.431 163.863 146.033 163.705L145 163.671V168.506L145.329 168.575C146.035 168.718 146.749 168.818 147.467 168.874C148.267 168.943 149.134 168.977 150.042 168.977C151.169 168.993 152.293 168.841 153.374 168.525C154.326 168.236 155.203 167.745 155.943 167.085C156.599 166.502 157.105 165.773 157.418 164.959C157.739 164.122 157.901 163.235 157.896 162.34V152.092H157.066V162.342C157.072 163.135 156.928 163.923 156.644 164.665C156.377 165.359 155.946 165.981 155.387 166.479C154.736 167.058 153.964 167.49 153.125 167.744C152.125 168.035 151.085 168.175 150.042 168.158C149.152 168.158 148.311 168.125 147.539 168.059C146.913 168.005 146.34 167.934 145.83 167.839V164.51C146.216 164.661 146.622 164.803 147.036 164.933C147.636 165.1 148.259 165.178 148.882 165.162C149.662 165.201 150.441 165.055 151.153 164.736C151.692 164.473 152.121 164.033 152.367 163.492C152.609 162.958 152.741 162.381 152.754 161.797C152.777 161.211 152.788 160.552 152.788 159.839V151.346H148.137V148.512H155.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.703 156.395C223.142 156.167 223.489 155.798 223.687 155.349C223.893 154.876 223.996 154.366 223.988 153.852C224.016 153.265 223.887 152.681 223.616 152.158C223.367 151.739 222.987 151.41 222.533 151.22C222.171 151.071 221.782 150.996 221.389 150.998C220.948 150.985 220.349 150.979 219.618 150.979H218.519V156.82H219.076C220.177 156.82 220.911 156.811 221.322 156.793C221.806 156.764 222.278 156.628 222.703 156.395V156.395ZM219.191 156.001V151.797H219.618C220.342 151.797 220.932 151.804 221.373 151.817C221.691 151.813 222.006 151.871 222.301 151.988C222.621 152.117 222.891 152.344 223.07 152.635C223.256 153.013 223.341 153.432 223.317 153.852C223.324 154.23 223.25 154.605 223.099 154.953C222.966 155.252 222.732 155.496 222.437 155.644C222.087 155.836 221.697 155.949 221.297 155.974C220.908 155.991 220.219 156 219.189 156.001H219.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6096 79.0625H36.9096V82.5625H30.6096C25.6346 82.5625 22.0596 80.2875 22.0596 75.5375C22.0596 71.4875 25.2346 68.4875 30.6096 68.4875H31.1096V67.2375H34.6096V79.0625ZM29.5846 79.0625H31.1096V71.9875H29.7596C27.7096 71.9875 25.5596 73.2875 25.5596 75.5375C25.5596 77.8375 27.5096 79.0625 29.5846 79.0625ZM32.5096 65.3875C31.4596 65.3875 30.5596 64.7625 30.5596 63.5875C30.5596 62.5375 31.4096 61.8125 32.5096 61.8125C33.6346 61.8125 34.4596 62.5375 34.4596 63.5875C34.4596 64.7625 33.5596 65.3875 32.5096 65.3875ZM27.0846 65.3875C26.0346 65.3875 25.1346 64.7625 25.1346 63.5875C25.1346 62.5375 25.9846 61.8125 27.0846 61.8125C28.1846 61.8125 29.0346 62.5375 29.0346 63.5875C29.0346 64.7625 28.1346 65.3875 27.0846 65.3875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4316 82.5625V79.0625H39.5316V68.4875H43.0316V79.0625H45.7066V82.5625H36.4316ZM41.2816 87.8875C40.1816 87.8875 39.2316 87.2375 39.2316 86.0125C39.2316 84.9125 40.1316 84.1625 41.2816 84.1625C42.4566 84.1625 43.3316 84.9125 43.3316 86.0125C43.3316 87.2375 42.3816 87.8875 41.2816 87.8875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2207 82.5625V79.0625H50.6707V69.7375H54.1707V79.0625H56.7207C58.2207 79.0625 60.0207 78.3875 60.0207 75.9375V69.7375H63.5207V75.9375C63.5707 78.2125 64.7957 79.3125 66.6707 79.3125C68.6457 79.3125 69.6707 78.0875 69.6707 76.1625V66.7375H73.1457V75.7125C73.1457 80.5125 71.0207 82.8125 66.6707 82.8125C64.7707 82.8125 62.8457 82.2625 61.6957 80.4125C60.4207 81.7375 58.6207 82.5625 56.7207 82.5625H45.2207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6699 82.5625V62.2875H81.1699V79.0625H84.3699V82.5625H77.6699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8682 82.5625V79.0625H94.2432C94.4932 77.9625 94.6682 76.5375 94.6682 75.4875C94.6682 74.4625 94.3182 73.2375 93.4432 72.4625C92.7432 71.8375 91.7432 71.5125 90.4932 71.5125C89.1682 71.5125 88.1682 71.7875 86.8682 72.6125L85.4182 69.5625C87.0432 68.6375 88.8182 68.0125 90.9182 68.0125C92.9682 68.0125 94.6932 68.7125 95.8932 69.9375C97.2182 71.2625 98.1432 73.2375 98.1432 75.7625C98.1432 76.8875 98.0182 78.0125 97.8182 79.0625H100.518V82.5625H83.8682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.055 82.5625V79.0625H102.48C102.355 78.5625 102.305 78.0125 102.305 77.4625C102.305 73.2125 105.655 69.8125 109.78 69.8125C114.005 69.8125 117.38 73.1375 117.38 77.4625C117.38 78.0125 117.305 78.5625 117.205 79.0625H120.005V82.5625H115.33C113.93 84.0375 111.93 84.9375 109.78 84.9375C107.655 84.9375 105.705 84.0125 104.33 82.5625H100.055ZM109.78 81.4375C112.08 81.4375 113.88 79.7625 113.88 77.4125C113.88 75.0625 112.18 73.3125 109.78 73.3125C107.455 73.3125 105.805 75.1375 105.805 77.4125C105.805 79.6625 107.53 81.4375 109.78 81.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.513 82.5625V79.0625H121.963V62.2875H125.463V82.5625H119.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.6 82.5625V62.2875H134.1V82.5625H130.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8096 97.2875L40.3096 117.562H36.5346L34.8096 112.788H26.4096L24.7096 117.562H20.9346L28.4346 97.2875H32.8096ZM30.6096 100.987L27.6096 109.413H33.6096L30.6096 100.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3826 110.438C41.3826 106.188 44.5826 102.987 48.9326 102.987C50.8576 102.987 52.3826 103.412 53.8076 104.138L52.4076 107.288C51.4826 106.763 50.3826 106.413 49.0826 106.413C46.6576 106.413 45.0576 108.038 45.0576 110.438C45.0576 112.838 46.6576 114.438 49.0826 114.438C50.3826 114.438 51.4826 114.113 52.4076 113.562L53.8076 116.737C52.3826 117.462 50.8576 117.862 48.9326 117.862C44.5826 117.862 41.3826 114.713 41.3826 110.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.323 110.438C55.323 106.188 58.523 102.987 62.873 102.987C64.798 102.987 66.323 103.412 67.748 104.138L66.348 107.288C65.423 106.763 64.323 106.413 63.023 106.413C60.598 106.413 58.998 108.038 58.998 110.438C58.998 112.838 60.598 114.438 63.023 114.438C64.323 114.438 65.423 114.113 66.348 113.562L67.748 116.737C66.323 117.462 64.798 117.862 62.873 117.862C58.523 117.862 55.323 114.713 55.323 110.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8885 117.862C72.5635 117.862 69.2635 114.638 69.2635 110.438C69.2635 106.263 72.5635 102.987 76.8885 102.987C81.2135 102.987 84.5135 106.263 84.5135 110.438C84.5135 114.638 81.2135 117.862 76.8885 117.862ZM76.8885 114.438C79.3385 114.438 80.8385 112.663 80.8385 110.438C80.8385 108.237 79.3385 106.413 76.8885 106.413C74.4385 106.413 72.9385 108.237 72.9385 110.438C72.9385 112.663 74.4385 114.438 76.8885 114.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.858 114.088V103.487H99.358V116.838C97.333 117.513 95.758 117.862 93.333 117.862C89.733 117.862 86.958 116.463 86.958 112.088V103.487H90.458V111.088C90.458 113.663 91.258 114.438 93.233 114.438C94.008 114.438 94.833 114.363 95.858 114.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.398 117.562V103.713C105.573 103.313 108.198 102.987 109.723 102.987C113.323 102.987 116.223 104.138 116.223 108.763V117.562H112.723V109.763C112.723 107.188 111.648 106.413 109.573 106.413C108.823 106.413 107.898 106.513 106.898 106.688V117.562H103.398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.475 106.737V103.487H121.125V98.3375H124.625V103.487H129.975V106.737H124.625V111.838C124.625 113.738 125.275 114.312 127.125 114.312H130.075V117.562H126.75C122.85 117.562 121.125 116.463 121.125 113.088V106.737H118.475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.232 117.562V103.487H136.732V117.562H133.232ZM134.982 101.288C133.882 101.288 132.932 100.638 132.932 99.4125C132.932 98.3125 133.807 97.5625 134.982 97.5625C136.157 97.5625 137.007 98.3125 137.007 99.4125C137.007 100.538 136.182 101.288 134.982 101.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.752 117.562V103.713C142.927 103.313 145.552 102.987 147.077 102.987C150.677 102.987 153.577 104.138 153.577 108.763V117.562H150.077V109.763C150.077 107.188 149.002 106.413 146.927 106.413C146.177 106.413 145.252 106.513 144.252 106.688V117.562H140.752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.528 113.812V106.713C165.753 106.538 165.028 106.413 164.353 106.413C161.603 106.413 159.828 107.612 159.828 110.237C159.828 112.837 161.603 114.088 164.353 114.088C164.978 114.088 165.678 114.013 166.528 113.812ZM156.153 110.237C156.153 106.112 159.178 102.987 164.378 102.987C166.403 102.987 168.303 103.237 170.028 103.737V116.487C170.028 121.462 168.278 123.188 162.703 123.188C161.603 123.188 159.778 122.913 158.653 122.562L157.903 118.913C159.278 119.513 161.478 119.963 162.853 119.963C165.003 119.963 166.528 119.262 166.528 117.612V117.312C165.578 117.463 164.728 117.513 164.103 117.513C159.303 117.513 156.153 114.362 156.153 110.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.849 -14.9819C193.941 23.4956 209.44 104.179 302.376 120.366M302.376 120.366C302.772 120.435 303.169 120.502 303.569 120.569C397.565 136.27 341.938 126.975 302.376 120.366Z",
    stroke: "white",
    strokeWidth: 1.57009
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M149.627 -1.96711C165.56 33.274 219.464 95.2776 307.969 62.6286M307.969 62.6286C308.346 62.4894 308.724 62.3485 309.103 62.2058C398.281 28.6048 345.504 48.4873 307.969 62.6286Z",
    stroke: "white",
    strokeWidth: 1.57009
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_5438_171229",
    x: -284,
    y: -234,
    width: 569,
    height: 569,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.39155
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.316718 0 0 0 0 0.0126224 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5438_171229"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3915
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.26443
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5438_171229",
    result: "effect2_dropShadow_5438_171229"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 51
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5438_171229",
    result: "effect3_dropShadow_5438_171229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5438_171229",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_5438_171229",
    x: -208,
    y: -157,
    width: 416,
    height: 416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.39155
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.316718 0 0 0 0 0.0126224 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5438_171229"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3915
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.26443
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5438_171229",
    result: "effect2_dropShadow_5438_171229"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 51
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5438_171229",
    result: "effect3_dropShadow_5438_171229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5438_171229",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddd_5438_171229",
    x: -148,
    y: -97,
    width: 296,
    height: 296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.39155
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.316718 0 0 0 0 0.0126224 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5438_171229"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3915
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.26443
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5438_171229",
    result: "effect2_dropShadow_5438_171229"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 51
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5438_171229",
    result: "effect3_dropShadow_5438_171229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5438_171229",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5438_171229",
    x1: 0,
    y1: 0,
    x2: 246,
    y2: 185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#85E4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784375,
    stopColor: "#42D77D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5438_171229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 185,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountingCard);
export default __webpack_public_path__ + "static/media/accountingCard.0b0f1f2701a0563a241fedc1812d1afb.svg";
export { ForwardRef as ReactComponent };